const ACCIONES = {
  EDITAR: 'EDITAR',
  CREAR: 'CREAR'
}

class CarteraBasicRequest {

  constructor(cartera) {
    this.nombre = cartera.nombre
    this.descripcion = cartera.descripcion
    this.referenciaCliente = cartera.referenciaCliente
    this.operativa = cartera.operativa ? true : false
    this.idPadre = cartera.idPadre
    this.idLegalCliente = cartera.cliente ? cartera.cliente.idLegal : cartera.idLegalCliente
    this.idLegalUsuarioCliente = cartera.usuarioCliente ? cartera.usuarioCliente.idLegal : cartera.idLegalUsuarioCliente
    this.idLegalAcreedor = cartera.acreedor ? cartera.acreedor.idLegal : cartera.idLegalAcreedor
    this.acreedorObligatorio = cartera.acreedorObligatorio ? true : false
    this.acreedorPorDefecto = cartera.acreedorPorDefecto ? true : false
    this.moverPadre = cartera.moverPadre
    this.iban = cartera.iban
  }

}

class EditarCarteraModel extends CarteraBasicRequest {

  constructor(cartera) {
    super(cartera)
    this.id = cartera.id
  }

}

var CarterasMixin = {
  methods: {
    getAccionEditar() {
      return ACCIONES.EDITAR
    },
    getAccionCrear() {
      return ACCIONES.CREAR
    },
    getNuevaCarteraModel(idPadre, idLegalCliente) {
      const cartera = {
        idPadre: idPadre,
        idLegalCliente: idLegalCliente
      }

      return new EditarCarteraModel(cartera)
    },
    getEditarCarteraModel(cartera) {
      return new EditarCarteraModel(cartera)
    },
    toCarteraPutRequest(cartera) {
      return new CarteraBasicRequest(cartera)
    },
    toCarteraPostRequest(cartera) {
      return new CarteraBasicRequest(cartera)
    },
    mapToNodes(carteras) {
      if (!carteras || carteras.length === 0)
        return []

      return carteras.map(cartera => this.mapToNode(cartera, cartera.hijos))
    },
    mapToNode(cartera, hijos) {
      return {
        key: cartera.id,
        data: cartera,
        leaf: hijos ? hijos.length > 0 : [],
        label: cartera.nombre,
        children: hijos ? hijos.filter(carteraHijo => carteraHijo.idPadre == cartera.id).map(carteraHijo => this.mapToNode(carteraHijo, hijos)) : []
      }
    }
  }
};
export default CarterasMixin;